__turbopack_context__.v({
  "content": "style-module-scss-module__tZXNsq__content",
  "inner": "style-module-scss-module__tZXNsq__inner",
  "title": "style-module-scss-module__tZXNsq__title",
  "topPanel": "style-module-scss-module__tZXNsq__topPanel",
});
